'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MESSAGES_UPDATED = exports.MESSAGES_UPDATED = 'MESSAGES_UPDATED';
var MESSAGES_HARD_DELETED = exports.MESSAGES_HARD_DELETED = 'MESSAGES_HARD_DELETED';